module.exports = __webpack_public_path__ + "img/mealVoucherIcon.11b866cf.svg";